import { useMutation } from "@tanstack/react-query";
import { axios } from "lib/axios";
import { queryClient } from "lib/react-query";
import { useNavigate } from "react-router-dom";
import { useCentralStore } from "stores";

export const createRole = ({
  churchId,
  isDenomination = false,
  denominationId,
  roleData
}) => {
  return axios.post(
    `/${isDenomination ? "denominations" : "churches"}/${
      isDenomination ? denominationId : churchId
    }/roles`,
    roleData
  );
};

export const useCreateRole = ({ config } = {}) => {
  const setNotification = useCentralStore.getState().setNotification;
  const navigate = useNavigate();

  return useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries("roles");

      setNotification({
        type: "success",
        message: "Role created successfully!"
      });

      navigate("/users");
    },
    ...config,
    mutationFn: createRole
  });
};
